var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.155 18.238a1.314 1.314 0 0 0-2.141 1.442c.07.16.17.304.296.424a11.732 11.732 0 0 1 3.503 8.396c0 1.605-4.602 3.938-11.813 3.938s-11.813-2.334-11.813-3.94a11.732 11.732 0 0 1 3.459-8.352A1.313 1.313 0 1 0 4.79 18.29 14.342 14.342 0 0 0 .563 28.5C.563 32.763 8 35.063 15 35.063c7 0 14.438-2.3 14.438-6.563a14.333 14.333 0 0 0-4.283-10.262Z",
    fill: "#00ff40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.313a9.187 9.187 0 1 0-9.188-9.188A9.198 9.198 0 0 0 15 19.313Zm0-15.75a6.563 6.563 0 1 1-6.563 6.562A6.57 6.57 0 0 1 15 3.562Z",
    fill: "#35FF62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.ffe4cc3629b6d8a8e4c18e382b68805d.svg";
export { ForwardRef as ReactComponent };